import { Center, ColorMode, Portal, useColorMode } from '@chakra-ui/react'
import { EditableStateProvider, ScreenContext, useAuth, useScreen } from '@hb/react'
import {
  APP_HEADER_HEIGHT_PX,
  AppHeader,
  Container,
  CookieBanner,
  LoadingOverlay,
  Menu,
  MessagesWidget,
  PopUpMessageOverlay,
  RootModals,
  siteVersions,
  useFilteredViews,
  useForceColorMode,
  UserAssessmentsProvider,
  useViewRoutes,
  WebThreadsListProvider,
} from '@hb/react-web'

import { version } from '@hb/shared'
import { CSSProperties, useMemo } from 'react'
import { Route, Routes, useLocation } from 'react-router'
import { views } from './views'

const getContainerStyle = (loading: boolean, colorMode: ColorMode): CSSProperties => ({
  justifyContent: 'flex-start',
  opacity: loading ? 0 : 1,
  transition: `opacity 333ms ease ${loading ? 0 : 333}ms`,
  boxSizing: 'border-box',
  height: '100vh',
  background:
    colorMode === 'dark' ? siteVersions[version].darkBackground : siteVersions[version].background,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
})
const App = () => {
  useForceColorMode()
  const loading = useAuth(s => s.loading)
  const user = useAuth(s => s.user)
  const { colorMode } = useColorMode()
  const style = useMemo(() => getContainerStyle(loading, colorMode), [loading, colorMode])
  const filteredViews = useFilteredViews(views)
  const routes = useViewRoutes(filteredViews)

  const { pathname } = useLocation()
  const isIntakeForm = pathname.startsWith('/gyn-intake-form')

  const screen = useScreen()
  const { height } = screen
  return (
    <ScreenContext.Provider value={screen}>
      <UserAssessmentsProvider>
        <EditableStateProvider>
          <Portal>
            <WebThreadsListProvider views={filteredViews}>
              <Container style={style}>
                {isIntakeForm ? null : <AppHeader views={filteredViews} />}
                <Center
                  position="relative"
                  w="100%"
                  height={isIntakeForm ? '100vh' : `${height - APP_HEADER_HEIGHT_PX}px`}>
                  <Routes>
                    {routes.map(({ path, component }) => (
                      <Route key={path} path={path} Component={component} />
                    ))}
                  </Routes>
                </Center>
                {isIntakeForm ? null : <Menu views={filteredViews} />}
                {isIntakeForm ? null : <MessagesWidget />}
              </Container>
              {/* <UserPanel /> */}
              {/* <TestButton /> */}
              <RootModals />
              <LoadingOverlay
                style={{ fontSize: '21px', fontFamily: 'Comfortaa' }}
                height={100}
                loading={loading || user?.settingUpFromInvite}
                text={user?.settingUpFromInvite ? 'Setting up your account...' : 'Hamilton Billing'}
                withSignOut
              />
              <CookieBanner />
            </WebThreadsListProvider>
          </Portal>
          <PopUpMessageOverlay />
        </EditableStateProvider>
      </UserAssessmentsProvider>
    </ScreenContext.Provider>
  )
}

export default App
